import Vue from "vue";
import Vuex, { MutationTree, ActionTree } from "vuex";
import { Event } from "../../../models/event";
import { Status } from "../../../models/status";
import axios from 'axios';

Vue.use(Vuex);

interface State {
    newestEvent: Event;
}

const mutations: MutationTree<State> = {
    setNewestEvent: (state, event) => (Object.assign(state.newestEvent, event)),
};

const actions: ActionTree < State, any > = {

};

const getters = {
   
    newestEvent(state: State)  {
        return state.newestEvent
    },
};


const state: State = {
    newestEvent: {
        text:'',
        status: <Status>  {
        },
        push:false,
    },
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/vuex/modules/event/store.ts